import urlJoin from 'url-join'

import { env } from '@/shared/config'

export function getLegalLinkHref(lang: string, path: string) {
    return urlJoin(env.LEGAL_URL, lang, path)
}
